import * as Sentry from "@sentry/nextjs";

export interface IPValue {
  access_from: string;
}

export interface IPError {
  access_from?: ValidationError;
}

const FetchIP = (
  ipClient: () => Promise<string>,
  updateValue: (prop: keyof IPValue, value: any) => void,
  updateError: (prop: keyof IPError, value: any) => void
) => {
  const fetchIP = async () => {
    try {
      const ip = await ipClient();
      updateValue("access_from", ip);
    } catch (error) {
      Sentry.captureException(error);
      updateValue("access_from", "");
      updateError("access_from", {
        type: "manual",
        message:
          "Failed to automatically get IP address. Enter your IPv4 address manually, or enter 0.0.0.0/0 to make your workflow accessible to all IP addresses.",
      });
    }
  };

  return fetchIP;
};

export default FetchIP;
